import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { headStyle } from '@/components/ui/Typography/Heading/Head/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProMypageSection のスタイル
 */
export const hotlineProMypageSectionStyle = tv({
    slots: {
        ScheduledSection: ['mt-40'],
        base: ['p-16 lg:p-24', 'bg-white'],
        description: [
            'flex flex-col gap-16',
            'p-16',
            'mt-16',
            'bg-blue-gray-75',
            'rounded-md',
        ],
        descriptionLink: [linkTextStyle({ isBold: true, size: 'sm' })],
        descriptionText: [textStyle({ color: 'base', size: 'sm' })],
        newSection: ['mt-32'],
        newSectionButton: ['mt-16 mx-auto'],
        title: [headStyle({ isBold: true, size: 'sm' }), 'text-blue-gray-400'],
    },
});
